const trimTrailingSlash = (value?: string | null) =>
  value ? value.replace(/\/$/, "") : ""

const normalizePath = (path: string) =>
  path.startsWith("/") ? path : `/${path}`

export const API_DOMAIN = trimTrailingSlash(process.env.REACT_APP_API_DOMAIN)

/**
 * If `REACT_APP_API_DOMAIN` is `…/dashboard-apis…/api/v1/ecards`, map to the dedicated
 * ecards host so Vivint GETs are not merged into axios `baseURL` as `…/ecards/vivint/…`.
 */
function inferEcardsVivintBaseFromApiDomain(): string {
  if (!API_DOMAIN || !/dashboard-apis\.evolutionsmarthome\.com/i.test(API_DOMAIN)) {
    return ""
  }
  let u = API_DOMAIN.trim()
  u = u.replace(
    /^(https?:\/\/)(?:stage-)?dashboard-apis\.evolutionsmarthome\.com/i,
    "$1ecards.evolutionsmarthome.com"
  )
  u = u.replace(/\/ecards\/?$/i, "")
  return trimTrailingSlash(u)
}

/**
 * Host for Vivint sidebar APIs (Vivint Ads, Vivint Candidates, Vivint Weekly Trainings).
 * Prefer `REACT_APP_ECARDS_VIVINT_BASE_URL`; otherwise infer ecards host from API_DOMAIN
 * so requests are absolute (`https://ecards…/api/v1/vivint/…`) and do not hit dashboard-apis.
 */
export const ECARDS_VIVINT_BASE_URL =
  trimTrailingSlash(process.env.REACT_APP_ECARDS_VIVINT_BASE_URL || "") ||
  inferEcardsVivintBaseFromApiDomain()

const buildUrl = (fallbackPath: string, override?: string | null) => {
  if (override) {
    return override
  }
  const normalizedPath = normalizePath(fallbackPath)
  return API_DOMAIN ? `${API_DOMAIN}${normalizedPath}` : normalizedPath
}

export const withApiBaseUrl = (path: string) => buildUrl(path)

const snowflakeEnv = trimTrailingSlash(process.env.REACT_APP_SNOWFLAKE_API_URL)

const resolveSnowflakeUrl = () => {
  if (snowflakeEnv) {
    return snowflakeEnv
  }
  if (API_DOMAIN) {
    return `${API_DOMAIN}/ecards`
  }
  return ""
}

export const SNOW_FLAKE_URL = trimTrailingSlash(resolveSnowflakeUrl())

const withSnowflakeBase = (path: string) =>
  SNOW_FLAKE_URL ? `${SNOW_FLAKE_URL}${normalizePath(path)}` : undefined

export const AUTH_LOGIN_URL = buildUrl(
  "/helper/admin",
  withSnowflakeBase("/helper/admin")
)

export const AUTH_VERIFY_URL = buildUrl(
  "/helper/verify_auth_code",
  withSnowflakeBase("/helper/verify_auth_code")
)

export const AUTH_RESEND_URL = buildUrl(
  "/helper/resendcode",
  withSnowflakeBase("/helper/resendcode")
)

export const MOBILE_API_URL = trimTrailingSlash(
  process.env.REACT_APP_MOBILE_API_URL
)

export const GHL_WEBHOOK_URL = process.env.REACT_APP_GHL_WEBHOOK_URL || ""

export const STRIPE_SETUP_INTENT_URL =
  process.env.REACT_APP_STRIPE_SETUP_INTENT_URL || ""

export const STRIPE_SETUP_INTENT_EMAIL =
  process.env.REACT_APP_STRIPE_SETUP_INTENT_EMAIL || ""

export const STRIPE_PUBLIC_KEY =
  process.env.REACT_APP_STRIPE_PUBLIC_KEY || ""

export const REFRESH_TOKEN_URL =
  process.env.REACT_APP_REFRESH_TOKEN_URL ||
  (API_DOMAIN ? `${API_DOMAIN}/dashboard/refreshtoken` : "")


